





















import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class UiVideoControlComponent extends Vue {
  @Prop({ default: false })
  src!: string | Blob;
  @Prop()
  name!: string;
  isPlay: boolean = false;
  duration: number = 0;
  currentTime: number = 0;
  temp: number = 0;
  wrapperStyle: Object  = { };
  @Watch('src')
  onSrcChanged() {
    this.stopWatch();
    this.isPlay = false;
  }
  get percentCompelete(): number {
    if (!this.currentTime || !this.duration) {
      return 0;
    }
    return (this.currentTime / this.duration)*100;
  }
  setCurrentTime(value : number) {
    this.videoEl.currentTime = value;
    this.currentTime = value;
  }
  get durationDisplay(): string {
    if (!this.duration) {
      return '00:00';
    }
    const minutes = Math.floor(this.duration / 60);
    const seconds = Math.floor(this.duration % 60);
    const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const displaySeconds = seconds < 10 ? `0${seconds}` : seconds;
    return `${displayMinutes}:${displaySeconds}`;
  }
  timeout: NodeJS.Timeout;
  get videoEl(): HTMLVideoElement {
    return this.$refs.videoEl as HTMLVideoElement;
  }
  onChangeTrack(e: Event) {
    var trg = e.target as HTMLInputElement;
    this.setCurrentTime(Number(trg.value));
  }
  playStop() {
    this.isPlay = !this.isPlay;
    if (this.isPlay) {
      this.videoEl.play();
      this.startWatch();
    } else {
      this.videoEl.pause();
      this.stopWatch();
    }
  }
  beforeDestroy() {
    this.stopWatch();
  }
  stopWatch() {
    this.timeout && clearInterval(this.timeout);
    this.timeout = null;
  }
  startWatch() {
    if(this.timeout) {
      return;
    }
    this.timeout = setInterval(this.refreshTime, 1000);
  }
  refreshTime() {
    this.currentTime = this.videoEl.currentTime;
  }
  loadedmetadata(e: Event) {
    const d = this.videoEl;
    this.duration = (e.target as HTMLMediaElement).duration;
    
    this.wrapperStyle = {
      maxWidth: `${this.videoEl.clientWidth}px`,
      maxHeight: `${this.videoEl.clientHeight}px`
    };
  }
  onPause(e: any) {
    this.isPlay = false;    
    this.stopWatch();
  }
  onEnd() {
    this.isPlay = false;
    this.stopWatch();
  }
  onStart() {
    this.startWatch();
  }
}
